import { queryClient } from '@ui/lib/reactQuery';
import { useEffect } from 'react';

import { startStreaming } from './streaming';
import { usePriceStream } from './usePriceStream';

const hardStartIfClosed = async () => {
  const stream = queryClient.getQueryData<
    ReadableStreamDefaultReader<Uint8Array> | undefined
  >(usePriceStream.getKey());
  const readed = await stream?.read();
  const isClosed = !readed || readed.done === true;
  if (isClosed) {
    startStreaming(undefined, undefined, true);
  }
};
export const useReconnectStream = () => {
  useEffect(() => {
    window.addEventListener('focus', hardStartIfClosed);

    return () => {
      window.removeEventListener('focus', hardStartIfClosed);
    };
  }, []);
};
